import { render, staticRenderFns } from "./facial-reader.vue?vue&type=template&id=2646ccac&scoped=true&"
import script from "./facial-reader.vue?vue&type=script&lang=js&"
export * from "./facial-reader.vue?vue&type=script&lang=js&"
import style0 from "./facial-reader.vue?vue&type=style&index=0&id=2646ccac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646ccac",
  null
  
)

export default component.exports